<template>
  <div class="case-digital-mlpa-dailog dialog col-block width-full">
    <div class="case-digital-mlpa-container col-block width-full">
      <div class="case-digital-mlpa-title-container row-block">
        <div class="case-digital-mlpa-title">{{ $t('DIALOG.caseDigitalMLPA.___title') }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <template v-if="selectedProjectID">
        <div :style="{ height: '10px' }"></div>
        <div class="case-digital-mlpa-top-container col-block width-full">
          <div class="case-digital-mlpa-top-block row-block">
            <div class="case-digital-mlpa-project-list-container col-block width-full">
              <analysisBorCor
                :display="projectDatas.length ? null : false"
                :arrow="false"
                :type="'right'"
                :background="'white'"
                :border="'#CCCCCC'"
                :radius="'5px'"
                :blockStyle="{ padding: '10px' }"
                :cursorSize="'40px 40px'"
                :translate="'-5.5px -1px'"
              >
                <div slot="trigger">
                  <div class="icon-block" :style="{ '--size': '40px' }">
                    <img :src="require('../../assets/images/project-list-icon.svg')" alt="">
                  </div>
                </div>
                <div class="content col-block" slot="content">
                  <template v-if="!hiddenAnalysisSelect">
                    <div class="project-list-block col-block stretch">
                      <div class="project-card-container col-block flex-start" :class="{ active: selectedProjectID === String(project.id) }" v-for="(project, pindex) in projects" :key="pindex" @click="e => setProjectID(project.id)">
                        <div class="project-card-title-container row-block">
                          <div class="project-card-title-block row-block">
                            <div class="project-card-title">{{ project.kit_name }}</div>
                          </div>
                          <div class="project-state-icon icon-block" :class="[project.state]" :style="{ '--size': '20px', 'cursor': 'default' }">
                            <img
                              v-if="[
                                'analyzing',
                                'started',
                                'failed',
                                'completed'
                              ].includes(project.state)"
                              :src="require('../../assets/images/project-' + project.state + '-icon.svg')"
                              alt=""
                            >
                          </div>
                        </div>
                        <div class="project-card-info-container col-block">
                          <div class="project-card-info-block row-block" v-for="(option, oindex) in projectCardOptions" :key="oindex">
                            <div class="project-card-info-title">{{ option.title + ':' }}</div>
                            <div class="project-card-info-content">{{ option.value(project) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div :style="{ height: '10px' }"></div>
                    <div class="project-list-button-container row-block">
                      <div :style="{ flex: 1 }"></div>
                      <button class="white-gray-button circle-button" :disabled="projectDatas.length >= limit" @click="e => setProjectID()">
                        <span>{{ $t('COMMON.button.___newAnalysis') }}</span>
                      </button>
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </template>
                </div>
              </analysisBorCor>
            </div>
            <div class="case-digital-mlpa-project-title-container row-block" :style="{ flex: 1 }">
              <div class="case-digital-mlpa-project-title shrink ellipsis">{{ (currentProject || {}).kit_name || $t('DIALOG.caseDigitalMLPA.___empty') }}</div>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="case-digital-mlpa-project-option-container row-block">
              <div
                class="custom-option-block center-block"
                v-for="(option, index) in topOptions.filter(option => option.display !== false)"
                :key="index"
                :class="
                  option.value ? {
                    default: option.hover === false,
                    hover: option.hover !== false && !option.disabled,
                    disabled: option.disabled,
                    alert: option.alert
                  } : ['line']
                "
                :style="{ '--size': '40px' }"
                @click="e => !option.disabled && option.func && option.func()"
              >
                <img v-if="option.value" :src="option.icon" alt="" :title="option.title" :style="option.style || {}">
              </div>
            </div>
          </div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="case-digital-mlpa-top-main-container col-block width-full">
          <keep-alive>
            <digitalMLPA
              v-if="selectedProjectID"
              :key="selectedProjectID"
              :projects="projects"
              :projectID="selectedProjectID"
              @create="data => createProject(data)"
            ></digitalMLPA>
          </keep-alive>
        </div>
      </template>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getCaseDigitalMLPA, postCaseDigitalMLPA, deleteCaseDigitalMLPA } from '../../api'
import digitalMLPA from '../digitalMLPA/main.vue'
import analysisBorCor from '../tool/analysisBorCor.vue'
import routeLoading from '../../mixins/routeLoading.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import { dateFormat, sortData } from '../../constants/global/util'

export default {
  components: {
    digitalMLPA,
    analysisBorCor
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      projectDatas: [],
      selectedProjectID: null,
      hiddenAnalysisSelect: false,
      limit: 3
    }
  },
  computed: {
    currentProject () {
      return this.projects.find(project => String(project.id) === this.selectedProjectID)
    },
    projects () {
      return this.projectDatas.map(projectData => ({
        ...projectData
      }))
    },
    // static
    projectCardOptions () {
      return [
        {
          title: this.$t('DIALOG.caseDigitalMLPA.card.title.___created'),
          value: data => dateFormat(new Date(data.created_at), 'yyyy/MM/dd hh:mm:ss')
        }
      ]
    },
    topOptions () {
      return [
        {
          title: this.$t('DIALOG.caseDigitalMLPA.top.icon.title.___delete'),
          value: 'delete',
          icon: require('../../assets/images/case-detail-delete-icon.svg'),
          alert: true,
          display: !!this.currentProject,
          disabled: ['analyzing'].includes((this.currentProject || {}).state),
          func: () => this.deleteProject(this.currentProject)
        }
      ]
    },
    // param
    caseData () {
      return this.param.caseData
    }
  },
  methods: {
    ...mapActions([
      'setModal2Action',
      'setLoadingAction'
    ]),
    async fetchData () {
      await this.fetchProjects()
    },
    async fetchProjects () {
      try {
        let config = this.$ls.get('userInfo')
        let caseID = this.caseData.id
        let response = await getCaseDigitalMLPA(caseID, config)
        let projects = response.data.data
        projects = sortData(projects.map(project => this.parseProject(project)), 'created_at', 'desc')
        this.setProjectID((projects[0] || {}).id)
        this.projectDatas = projects
      } catch (error) {
        throw error
      }
    },
    parseProject (project) {
      let kitName = Object.keys(project).find(key => key.endsWith('.xml'))
      let result = { ...project }
      delete result[kitName]
      return {
        id: project.digitalmlpa_id,
        kit_name: kitName,
        state: 'completed',
        ...result,
        ...project[kitName]
      }
    },
    async createProject (data) {
      this.setLoadingAction(true)
      try {
        let config = this.$ls.get('userInfo')
        let caseID = this.caseData.id
        let file = data.file
        let response = await postCaseDigitalMLPA(caseID, file, config)
        await this.fetchProjects()
        this.addToast('success', response.data.result.message)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
      this.setLoadingAction(false)
    },
    deleteProject (project) {
      this.setModal2Action({
        action: 'toast',
        width: '496px',
        customStyles: {
          padding: 0,
          border: 0
        },
        param: {
          type: 'alert',
          content: this.$t('DIALOG.caseDigitalMLPA.modal.content.___deleteAlert'),
          buttons: [
            {
              title: this.$t('COMMON.button.___yes'),
              type: 'alert',
              result: true
            },
            {
              title: this.$t('COMMON.button.___cancel'),
              type: 'gray',
              result: false
            }
          ]
        },
        callback: async result => {
          if (result) {
            this.setLoadingAction(true)
            try {
              let config = this.$ls.get('userInfo')
              let caseID = this.caseData.id
              let mlpaID = project.id
              let response = await deleteCaseDigitalMLPA(caseID, mlpaID, config)
              await this.fetchProjects()
              this.addToast('success', response.data.result.message)
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data.result.message)
            }
            this.setLoadingAction(false)
          }
        }
      })
    },
    setProjectID (id) {
      this.selectedProjectID = String(id || ((this.selectedProjectID || '').startsWith('date-') ? this.selectedProjectID : ('date-' + dateFormat(new Date(), 'yyyyMMddhhmmssS'))))
      this.hiddenAnalysisSelect = true
      setTimeout(() => { this.hiddenAnalysisSelect = false }, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDigitalMLPA.vue